import { fetchApi } from '@/config/axiosSetting';
import {
  GetPoliceReportFunctionParamsType,
  GetPoliceReportQueryResponseType,
} from '@/modules/adjusterReportModules/adjusterReport/queries/policeReport/getPoliceReport/getPoliceReportQuery.type';

export const getPoliceReportFunction = (
  params: GetPoliceReportFunctionParamsType,
): Promise<GetPoliceReportQueryResponseType> => {
  return fetchApi.get(`${params.id}/report/police_report/`);
};
